<template>
  <div class="f-row no_nav_titles_height">
    <div
      class="row f-row justify-content-center"
      style="vertical-align: middle!important;"
    >
      <div class="col col-12 text-center">
        <label
          :for="'selectMonth'"
          class="toggle__button_rt"
          style="height: 100%; width: 100%; margin: auto!important;"
          :class="{ actives: newCurrMonth }"
        >
          <input
            type="checkbox"
            @click="onUserSelectMonth"
            :id="'selectMonth'"
            v-model="newCurrMonth"
          />
          <span class="toggle__switch_rt">
            <div
              class="row f-row justify-content-center"
              style="min-width: 220px;"
            >
              <div
                class="col col-6 txt-label-primary-2 text-center"
                style="font-size: 0.95rem!important;"
              >
                Past Month
              </div>
              <div
                class="col col-6 txt-label-primary-2 text-center"
                style="font-size: 0.95rem!important;"
              >
                Current Month
              </div>
            </div>
          </span>
        </label>
      </div>
    </div>
    <!-- === table headers ===-->
    <div
      class="row f-row justify-content-center"
      style="vertical-align: middle!important;"
    >
      <div class="col col-10 mt-2 text-center" v-if="showLoadingFepTable">
        <DataTable
          :scrollable="true"
          :scrollHeight="screenHeight + 'px'"
          :value="skeletonTable"
          class="p-datatable-sm"
          responsiveLayout="scroll"
          stickyHeader="true"
        >
          <Column field="date" header="Date">
            <template #body>
              <div class="row f-row justify-content-start">
                <div class="col col-10"><Skeleton /></div>
              </div>
            </template>
          </Column>
          <Column field="price1" header="BMD (MYR/mt)">
            <template #body>
              <div class="row f-row justify-content-start">
                <div class="col col-10"><Skeleton /></div>
              </div>
            </template>
          </Column>
          <Column field="price1" header="USD/MYR">
            <template #body>
              <div class="row f-row justify-content-start">
                <div class="col col-10"><Skeleton /></div>
              </div>
            </template>
          </Column>
          <Column field="price1" header="BMD (USD/mt)">
            <template #body>
              <div class="row f-row justify-content-start">
                <div class="col col-10"><Skeleton /></div>
              </div>
            </template>
          </Column>
          <Column field="price1" header="USD/COP">
            <template #body>
              <div class="row f-row justify-content-start">
                <div class="col col-10"><Skeleton /></div>
              </div>
            </template>
          </Column>
          <Column field="price1" header="CIF ROTT (USD/mt)">
            <template #body>
              <div class="row f-row justify-content-start">
                <div class="col col-10"><Skeleton /></div>
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
      <div class="col col-10 mt-2" v-else>
        <table class="table table-sm table-borderless real_time_table">
          <thead class="table-headers text-center align-center thead">
            <tr>
              <th v-for="(item, index) in histHeaders" v-bind:key="index">
                {{ item }}
              </th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
    <div
      class="row f-row justify-content-center"
      style="vertical-align: middle!important;"
    >
      <div
        class="col col-10"
        v-if="!showLoadingFepTable"
        style="height: calc(100vh - 340px); overflow: auto;"
      >
        <table class="table table-sm table-borderless real_time_table">
          <tbody>
            <tr v-for="(item, index) in newFepHistData" v-bind:key="index">
              <td
                v-bind:class="{ 'row-hover': highlightRow === index }"
                @mouseover="onHoverRow(index)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ item.date | dateFormat }}
              </td>
              <td
                v-bind:class="{ 'row-hover': highlightRow === index }"
                @mouseover="onHoverRow(index)"
                @mouseleave="onHoverRow(-1)"
              >
                <span v-if="isFinite(item.bmd) && item.bmd != null">
                  {{ item.bmd | priceFormat }}
                </span>
                <span v-else-if="item.bmd === 'N.A'">
                  {{ item.bmd }}
                </span>
                <InputNumber
                  style="padding: 0 10px 0 10px!important"
                  v-else
                  :tableFormat="true"
                  v-model="bmd"
                />
              </td>
              <td
                v-bind:class="{ 'row-hover': highlightRow === index }"
                @mouseover="onHoverRow(index)"
                @mouseleave="onHoverRow(-1)"
              >
                <span v-if="isFinite(item.myr) && item.myr != null">
                  {{ item.myr | priceFormat }}
                </span>
                <span v-else-if="item.myr === 'N.A'">
                  {{ item.myr }}
                </span>
                <InputNumber
                  style="padding: 0 10px 0 10px!important"
                  v-else
                  :tableFormat="true"
                  v-model="myr"
                />
              </td>
              <td
                v-bind:class="{ 'row-hover': highlightRow === index }"
                @mouseover="onHoverRow(index)"
                @mouseleave="onHoverRow(-1)"
              >
                <span v-if="isFinite(item.bmd_usd) && item.bmd_usd != null">
                  {{ item.bmd_usd | priceFormat }}
                </span>
                <span v-else-if="item.bmd_usd === 'N.A'">
                  {{ item.bmd_usd }}
                </span>
                <InputNumber
                  style="padding: 0 10px 0 10px!important"
                  v-else
                  :tableFormat="true"
                  v-model="bmd_usd"
                />
              </td>
              <td
                v-bind:class="{ 'row-hover': highlightRow === index }"
                @mouseover="onHoverRow(index)"
                @mouseleave="onHoverRow(-1)"
              >
                <span v-if="isFinite(item.cop) && item.cop != null">
                  {{ item.cop | priceFormat }}
                </span>
                <span v-else-if="item.cop === 'N.A'">
                  {{ item.cop }}
                </span>
                <InputNumber
                  style="padding: 0 10px 0 10px!important"
                  v-else
                  :tableFormat="true"
                  v-model="cop"
                />
              </td>
              <td
                v-bind:class="{ 'row-hover': highlightRow === index }"
                @mouseover="onHoverRow(index)"
                @mouseleave="onHoverRow(-1)"
              >
                <span v-if="isFinite(item.rott) && item.rott != null">
                  {{ item.rott | priceFormat }}
                </span>
                <span v-else-if="item.rott === 'N.A'">
                  {{ item.rott }}
                </span>
                <InputNumber
                  style="padding: 0 10px 0 10px!important"
                  v-else
                  :tableFormat="true"
                  v-model="rott"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      class="row f-row justify-content-center"
      style="vertical-align: middle!important;"
    >
      <div class="col col-10 mt-1">
        <table class="table table-sm table-borderless real_time_table tableBdr">
          <thead class="table-headers text-center align-center thead">
            <tr>
              <th v-for="(item, index) in histHeaders" v-bind:key="index">
                {{ item }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="tableBig">
                {{ date_ave | monthFormat }}
              </td>
              <td class="tableBig">
                {{ bmd_ave | priceFormat }}
              </td>
              <td class="tableBig">
                {{ myr_ave | priceFormat }}
              </td>
              <td class="tableBig">
                {{ bmd_usd_ave | priceFormat }}
              </td>
              <td class="tableBig">
                {{ cop_ave | priceFormat }}
              </td>
              <td class="tableBig">
                {{ rott_ave | priceFormat }}
              </td>
            </tr>
          </tbody>
          <thead class="table-headers text-center align-center thead">
            <tr>
              <th colspan="6" style="font-size: 1rem;">
                FEP
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>FREIGHT (USD/mt)</td>
              <td>
                <InputNumber
                  :tableFormat="true"
                  :value="newFreight"
                  @input="(val) => onUserFreightChange(val)"
                />
              </td>
              <td>TARIFF (%)</td>
              <td>
                <InputNumber
                  :tableFormat="true"
                  :value="newTariff"
                  @input="(val) => onUserTariffChange(val)"
                />
              </td>
              <td>PRICE (COP/mt)</td>
              <td class="tableBig">{{ fepPrice | priceFormat }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mean, timeFormat, format } from "d3";
import Column from "primevue/column";
import InputNumber from "@/components/InputNumber";
import DataTable from "primevue/datatable";
import Skeleton from "primevue/skeleton";
import { getSkeletonTable } from "@/_core/_helpers/_helpers";

export default {
  name: "CPOTable",
  components: {
    Column,
    DataTable,
    InputNumber,
    Skeleton,
  },
  props: {
    currMonth: { required: true, type: Boolean, default: true },
    fepHistData: { required: true, default: () => [] },
    fepTableData: { required: true, default: () => [] },
    freight: { required: true },
    showLoadingFepTable: { required: true, type: Boolean, default: false },
    tariff: { required: true },
  },
  data() {
    return {
      freightRott: -110,
      bonusRott: 0,
      stopCalculation: true,
      newFreight: 0,
      newTariff: 0,
      bmd: null,
      bmd_usd: null,
      rott: null,
      cop: null,
      myr: null,
      date_ave: new Date(),
      bmd_ave: null,
      bmd_usd_ave: null,
      rott_ave: null,
      cop_ave: null,
      myr_ave: null,
      newCurrMonth: null,
      newFepHistData: [],
      highlightRow: -1,
      histHeaders: [
        "Date",
        "BMD (MYR/mt)",
        "USD/MYR",
        "BMD (USD/mt)",
        "USD/COP",
        "CIF ROTT (USD/mt)",
      ],
      histFields: ["bmd", "bmd_usd", "rott", "cop", "myr"],
      screenHeight: 100,
      skeletonTable: [],
      tableAveFields: ["bmd", "bmd_usd", "rott", "cop", "myr"],
      tableKnownFields: [
        "bmd_ave",
        "bmd_usd_ave",
        "rott",
        "cop_ave",
        "myr_ave",
      ],
    };
  },
  created() {
    this.skeletonTable = getSkeletonTable();
    this.screenHeight =
      document.getElementById("whole-page-div").clientHeight - 400;
  },
  mounted() {
    this.newCurrMonth = this.currMonth;
    if (this.fepHistData.length > 0) {
      this.newFepHistData = this.fepHistData;
      this.calculateAverages();
    }
    if (this.fepTableData.length > 0) {
      this.fepTableData[0]["bmd_usd_ave"] =
        this.fepTableData[0].bmd_ave / this.fepTableData[0].myr_ave;
      this.fepTableData[0]["bmd_usd"] =
        this.fepTableData[0].bmd / this.fepTableData[0].myr;
    }
  },
  watch: {
    freight() {
      this.newFreight = this.freight;
    },
    tariff() {
      this.newTariff = this.tariff;
    },
    currMonth(val) {
      this.newCurrMonth = val;
    },
    fepTableData(val) {
      this.fepTableData = val;
      this.fepTableData[0]["bmd_usd_ave"] =
        this.fepTableData[0].bmd_ave / this.fepTableData[0].myr_ave;
      this.fepTableData[0]["bmd_usd"] =
        this.fepTableData[0].bmd / this.fepTableData[0].myr;
      this.calculateAverages();
    },
    fepHistData(val) {
      this.newFepHistData = val;
      this.calculateAverages();
    },
    bmd(val) {
      if (this.stopCalculation) {
        return;
      }
      this.bmd_ave = mean(this.newFepHistData, function(d) {
        return Number.isFinite(d.bmd) && d.bmd != null ? d.bmd : val;
      });
      this.stopCalculation = true;
      this.bmd_usd = val / this.myr;
      let _this = this;
      this.bmd_usd_ave = mean(this.newFepHistData, function(d) {
        return Number.isFinite(d.bmd_usd) && d.bmd_usd != null
          ? d.bmd_usd
          : _this.bmd_usd;
      });
      setTimeout(() => {
        _this.stopCalculation = false;
      }, 250);
    },
    bmd_usd(val) {
      if (this.stopCalculation) {
        return;
      }
      this.bmd_usd_ave = mean(this.newFepHistData, function(d) {
        return Number.isFinite(d.bmd_usd) && d.bmd_usd != null
          ? d.bmd_usd
          : val;
      });
      this.stopCalculation = true;
      this.bmd = val * this.myr;
      let _this = this;
      this.bmd_ave = mean(this.newFepHistData, function(d) {
        return Number.isFinite(d.bmd) && d.bmd != null ? d.bmd : _this.bmd;
      });
      setTimeout(() => {
        _this.stopCalculation = false;
      }, 250);
    },
    rott(val) {
      if (this.stopCalculation) {
        return;
      }
      this.rott_ave = mean(this.newFepHistData, function(d) {
        return Number.isFinite(d.rott) && d.rott != null ? d.rott : val;
      });
    },
    cop(val) {
      if (this.stopCalculation) {
        return;
      }
      this.cop_ave = mean(this.newFepHistData, function(d) {
        return Number.isFinite(d.cop) && d.cop != null ? d.cop : val;
      });
    },
    myr(val) {
      if (this.stopCalculation) {
        return;
      }
      this.myr_ave = mean(this.newFepHistData, function(d) {
        return Number.isFinite(d.myr) && d.myr != null ? d.myr : val;
      });
      this.stopCalculation = true;
      this.bmd_usd = this.bmd / val;
      let _this = this;
      this.bmd_usd_ave = mean(this.newFepHistData, function(d) {
        return Number.isFinite(d.bmd_usd) && d.bmd_usd != null
          ? d.bmd_usd
          : _this.bmd_usd;
      });
      setTimeout(() => {
        _this.stopCalculation = false;
      }, 250);
    },
  },
  computed: {
    fepPrice() {
      return (
        (this.bmd_usd_ave + this.newFreight) *
        (1 + this.newTariff / 100) *
        this.cop_ave
      );
    },
    rottPrice() {
      return (this.rott + this.freightRott) * (1 + this.bonusRott) * this.cop;
    },
  },
  filters: {
    priceFormat: function(val) {
      if (!val) {
        return "";
      } else {
        return val === 0 ? "" : format(",.6r")(val);
      }
    },
    dateFormat: function(val) {
      return val === null || val === "" || val === 0
        ? "-"
        : timeFormat("%d %b %y")(val);
    },
    monthFormat: function(val) {
      return val === null || val === "" || val === 0
        ? "-"
        : timeFormat("%b %y")(val);
    },
  },
  methods: {
    onUserFreightChange(val) {
      this.$emit("eventOnUserFreightChange", val);
    },
    onUserTariffChange(val) {
      this.$emit("eventOnUserTariffChange", val);
    },
    onUserSelectMonth() {
      this.$emit("eventOnUserSelectMonth", !this.newCurrMonth);
    },
    calculateAverages() {
      let _this = this;
      this.stopCalculation = true;
      // initialize vars
      let nLen = this.newFepHistData.length;
      if (nLen === 0) {
        return;
      }
      this.histFields.forEach(function(field, i) {
        let ave = _this.fepTableData[0][_this.tableAveFields[i]];
        let known = _this.fepTableData[0][_this.tableKnownFields[i]];
        _this.newFepHistData.every(function(d, j) {
          if (d[field] != null && Number.isFinite(d[field])) {
            return true;
          } else {
            if (
              Number.isFinite(ave) &&
              ave != null &&
              Number.isFinite(known) &&
              known != null
            ) {
              _this[field] = (nLen * ave - j * known) / (nLen - j);
            } else {
              _this[field] = _this.newFepHistData[Math.max(0, j - 1)][field];
            }
            return false;
          }
        });
      });
      // averages
      this.date_ave = this.newFepHistData[0].date;
      this.bmd_ave = mean(this.newFepHistData, function(d) {
        return Number.isFinite(d.bmd) && d.bmd != null ? d.bmd : _this.bmd;
      });
      this.bmd_usd_ave = mean(this.newFepHistData, function(d) {
        return Number.isFinite(d.bmd_usd) && d.bmd_usd != null
          ? d.bmd_usd
          : _this.bmd_usd;
      });
      this.rott_ave = mean(this.newFepHistData, function(d) {
        return Number.isFinite(d.rott) && d.rott != null ? d.rott : _this.rott;
      });
      this.cop_ave = mean(this.newFepHistData, function(d) {
        return Number.isFinite(d.cop) && d.cop != null ? d.cop : _this.cop;
      });
      this.myr_ave = mean(this.newFepHistData, function(d) {
        return Number.isFinite(d.myr) && d.myr != null ? d.myr : _this.myr;
      });

      // reactivity
      setTimeout(() => {
        _this.stopCalculation = false;
      }, 250);
    },
    onHoverRow(idx) {
      this.highlightRow = idx;
    },
  },
};
</script>
<style scoped>
.toggle__button_rt .toggle__switch_rt::after,
.toggle__button_rt .toggle__switch_rt::before {
  content: "Past Month";
  font-size: 0.95rem !important;
}
.actives .toggle__switch_rt::after,
.actives .toggle__switch_rt::before {
  content: "Current Month";
}
.tableBig {
  background-color: var(--expo-alpha-3);
  border-bottom: 1px solid var(--symmetry-h);
  font-size: 1.2rem;
  color: var(--textactive);
}
.tableBdr {
  border-spacing: 2px 1px;
  border-collapse: separate !important;
}
</style>
